import React from "react";
import { Route, Routes } from "react-router-dom";
import CompanyModal from "./companies-list/CompanyModal";
import CompanyDetails from "./company-details/company-details";

const CompanyList = () => {
  return (
    <Routes>
      <Route path="/" element={<CompanyModal />} />
      <Route
        path="/:id/details"
        element={
          <CompanyDetails />
        }
      />
    </Routes>
  );
};

export default CompanyList;
